// Pure utility for decoding base64-encoded Shopify GIDs. Safe to import from
// client or server components - no env reads, no network, no Node-only APIs
// beyond Buffer (polyfilled by Next.js in the browser).
export function decodeShopifyId(base64Id: string): string {
  const decoded = Buffer.from(base64Id, 'base64').toString('utf-8')
  const parts = decoded.split('/')

  return parts[parts.length - 1]
}
